import { Card } from 'voxguru-v1/components/AuthCard/AuthCard.styles';

function AuthCard({ children }) {
  return <Card>{children}</Card>;
}

export default AuthCard;
